import { StaticDataService } from "../../core/staticDataService/StaticDataService";

/**
 * Orchestrates fetching all initial data required for the app to function.
 * This should be called at app startup (e.g., in SplashScreen).
 *
 * Currently fetches:
 * - Constants from Firebase Realtime Database
 *
 * Future additions can include:
 * - Moods
 * - Other static data
 */
export class InitialDataFeature {
  /**
   * Fetches all initial data required for the app.
   * @returns Promise that resolves when all initial data is loaded
   * @throws Error if any fetch operation fails
   */
  public static async fetchAll(): Promise<void> {
    try {
      // Fetch constants
      await StaticDataService.getInstance().fetchConstants();
    } catch (error) {
      console.error("Error fetching initial data:", error);
      throw error;
    }
  }
}
